/* RESPONSIBLE TEAM: team-frontend-tech */

import Controller from '@ember/controller';

export default class ModelBenchmark extends Controller {
  queryParams = ['iterations'];

  iterations = '100';
}
